import {client as http} from '../../http_client';

export default {
    state: {
        milestones: {
            pending_count: 0
        }
    },
    getters: {
        milestones: state => state.milestones
    },
    mutations: {
        SET_MILESTONES_COUNT(state, count) {
            state.milestones.pending_count = count;
        }
    },
    actions: {
        getMilestonesCount({commit}) {
            return new Promise((resolve, reject) => {
                http.get('/milestones/count', {force: true}).then(response => {
                    commit('SET_MILESTONES_COUNT', response.data.count || 0);
                    resolve(response.data);
                }).catch(err => {
                    console.error('Error getting milestones count:', err);
                    reject(err);
                });
            });
        }
    }
}
